module.exports = __webpack_public_path__ + "media/src/images/favicon-96x96-2aa5c911f42cd0f4531972c916df99bd.png";